// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"d292c596","453":"3924e7f0","991":"919679f9"}[chunkId] + ".chunk.js";
};